import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { TreeItem } from '../../models/tree-item';
import { ConnectProviderService } from 'app/connect/core/connect-provider.service';
import { PropertiesReplication } from '../../models/properties-replication';
import { DateUtil } from 'app/core/utils/DateUtil';

@Component({
  selector: 'connect-replication-detail-properties',
  templateUrl: 'connect-replication-detail-properties.component.html',
  styleUrls: ['connect-replication-detail-properties.component.scss']
})
export class ConnectReplicationDetailPropertiesComponent implements OnInit, OnChanges {
  public replicatedEntities: Array<TreeItem> = [];
  public infoReplicatedProperties: PropertiesReplication;
  public isLoading: boolean = false;
  @Input() currentItemSelected: TreeItem;

  constructor(private _connectProviderService: ConnectProviderService) {
  }

  ngOnInit() {
    this.infoReplicatedProperties = new PropertiesReplication();
  }

  ngOnChanges() {
    if (this.currentItemSelected) {
      this.isLoading = true;
      this._connectProviderService.getReplicatedEntities(this.currentItemSelected.id).subscribe((data) => {
        this.replicatedEntities = data;
        this.sortArray();
      });
      this._connectProviderService.getInfoById(this.currentItemSelected.id).subscribe((data: any) => {
        this.infoReplicatedProperties.name = data.name;
        this.infoReplicatedProperties.displayName = data.content.displayName;
        this.infoReplicatedProperties.description = data.content.description;
        this.infoReplicatedProperties.startDate = DateUtil.ensureUTC(data.content.schedules[0].startDate);
      });
      this.getNextRunTime();
    }
  }
  sortArray() {
    this.replicatedEntities.sort((a, b) => {
      const displayNameA = a.displayName.toLowerCase();
      const displayNameB = b.displayName.toLowerCase();

      if (displayNameA < displayNameB) {
        return -1;
      }
      if (displayNameA > displayNameB) {
        return 1;
      }
      return 0;
    });
  }

  scheduleNow() {
    this._connectProviderService.postScheduleNow(this.currentItemSelected.id).subscribe((data) => {
      this.infoReplicatedProperties.nextRunTime = DateUtil.ensureUTC(data.NextRunTime);
    });
  }

  getNextRunTime() {
    this._connectProviderService.getNextRunTime(this.currentItemSelected.id).subscribe((data) => {
      this.infoReplicatedProperties.nextRunTime = DateUtil.ensureUTC(data.NextRunTime);
      if (this.isLoading)
        this.isLoading = false;
    });
  }
}
